import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { MyBusinessRoutingModule } from './my-business-routing.module';
import { NewBusinessComponent } from './pages/new-business/new-business.component';
import { EditBusinessComponent } from './pages/edit-business/edit-business.component';
import { BusinessesComponent } from './pages/businesses/businesses.component';
import { BusinessFormComponent } from './components/business-form/business-form.component';
import { ProfitAndLossComponent } from './pages/profit-and-loss/profit-and-loss.component';
import { MyBusinessApiService } from './services/my-business.api.service';
import { MetricsModule } from '@app/modules/metrics/metrics.module';

@NgModule({
  declarations: [
    NewBusinessComponent,
    EditBusinessComponent,
    BusinessesComponent,
    BusinessFormComponent,
    ProfitAndLossComponent,
  ],
  imports: [CommonModule, MyBusinessRoutingModule, SharedModule, MetricsModule],
  providers: [MyBusinessApiService],
})
export class MyBusinessModule {}
